import { FC, useContext, useEffect } from "react";
import { useFetch } from "Hooks";
import { CaseContext } from "Stores";
import { TUseFetch, TWebDocumentDTO } from "Types";
import { AsynchronousWrapper, DocumentHeaderSplitter, WebDocument } from "Components";
// Style
import styles from "../technologyDocuments.module.scss";
import { PendoHelperSingleton } from "Helpers";
import { LoggingConstants } from "Constants";

export const TechnologyWebDocuments: FC = () => {

    // Shared states
    const { caseState } = useContext(CaseContext);

    // We use `useFetch` custom hook here
    // to fetch data from the server
    const { isLoading, didError, errorMessage, fetchedData }: TUseFetch<TWebDocumentDTO[]> = useFetch(`api/technologies/${caseState.selectedTechnologyId}/documents/web`);

    useEffect(() => {
        if(fetchedData) {
            // Log the retrieved webpages event
            PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}TechnologyGetWebpages`, {
                technologyId: caseState.selectedTechnologyId
            });
        }
    }, [caseState.selectedTechnologyId, fetchedData]);

    return (
        <AsynchronousWrapper didError={didError} errorMessage={errorMessage} isLoading={isLoading} LoaderComponent={null}>
            <div className={styles.technologyDocumentsContentContainer}>
                {fetchedData && fetchedData.length >= 1 ?
                    <DocumentHeaderSplitter title="Scout added documents" />
                    :
                    null
                }
                {fetchedData?.map((webDto) => {
                    return (
                        <WebDocument key={webDto.id} webDto={webDto} />
                    );
                })

                }
            </div>
        </AsynchronousWrapper>
    );
}
